// extracted by mini-css-extract-plugin
export default {"description":"MessageSent_description__Rypu4"};